/**
 * Store Locator Multi-Language Override
 * Version: 1.0.0
 *
 * HOW IT WORKS:
 * - Detects language from Shopify locale or URL param (?lang=xx)
 * - Overrides SCASLSetting values with translated strings
 * - Must load BEFORE Store Locator initializes
 *
 * INSTALLATION:
 * 1. Upload this file to Shopify theme Assets
 * 2. Add script tag in theme.liquid BEFORE Store Locator
 * 3. Update TRANSLATIONS object with your content
 */
(function() {
  'use strict';

  // ============================================
  // CONFIGURATION
  // ============================================

  var DEFAULT_LANG = 'en-gb';
  var SUPPORTED_LANGS = ['en-gb', 'sv-se', 'nb-no', 'de-de', 'pl-pl', 'es-es'];
  var DEBUG = true; // Set false in production

  // ============================================
  // TRANSLATIONS
  // Update these with client-provided translations
  // ============================================

  var TRANSLATIONS = {
    'en-gb': {
      // Search Box
      page_title: "Find Our Stores",
      curr_loc_text: "Current Location",
      radius_text: "Search Radius",
      find_loc_btn_text: "Find My Location",
      search_btn_text: "Search",
      enter_a_location_text: "Enter a location",
      filter_tags_text: "Filter Tags",
      location_is_disabled_alert: "Location Services Disabled",
      location_is_disabled_text: "Please turn on device location to use Find My Location",
      msr_text: "Search Radius Measurement",
      meter_unit_text: "Mile",
      kilometer_unit_text: "Kilometer",

      // Results
      no_result_title: "No results",
      no_result_tags: "No locations were found with the given tags. Please modify your selections or input.",
      add_error_alert: "Unable to find address",
      distance_error_alert: "Unfortunately, our closest location is more than",

      // Map & List
      direction_text: "Directions",
      view_map_btn_text: "View Map",
      list_text: "List",
      map_text: "Map",
      more_text: "More",
      less_text: "Less",

      // Operating Hours
      open_text: "Open",
      opens_text: "Opens",
      open_now_text: "Open now",
      closed_text: "Closed",
      closes_text: "Closes",
      closes_soon_text: "Closes soon",
      hours_might_differ: "Hours might differ",

      // Days
      monday_text: "Monday",
      tuesday_text: "Tuesday",
      wednesday_text: "Wednesday",
      thursday_text: "Thursday",
      friday_text: "Friday",
      saturday_text: "Saturday",
      sunday_text: "Sunday",

      // Units
      miles_text: "miles",
      kilometers_text: "kilometers",
      no_limit_text: "No Limit",

      // Contact Info
      phone_label_text: "Phone Number",
      email_label_text: "Email"
    },
    'sv-se': {
      // Search Box
      page_title: "Hitta återförsäljare",
      curr_loc_text: "Nuvarande plats",
      radius_text: "Sökradie",
      find_loc_btn_text: "Hitta min plats",
      search_btn_text: "Sök",
      enter_a_location_text: "Ange en plats",
      filter_tags_text: "Filtrera taggar",
      location_is_disabled_alert: "Platstjänster är inaktiverade",
      location_is_disabled_text: "Aktivera enhetens plats för att använda Hitta min plats",
      msr_text: "Måttenhet för sökradie",
      meter_unit_text: "Mil",
      kilometer_unit_text: "Kilometer",

      // Results
      no_result_title: "Inga resultat",
      no_result_tags: "Inga platser hittades med valda taggar. Ändra dina val eller inmatning.",
      add_error_alert: "Kunde inte hitta adressen",
      distance_error_alert: "Tyvärr är närmaste återförsäljare längre bort än",

      // Map & List
      direction_text: "Vägbeskrivning",
      view_map_btn_text: "Visa karta",
      list_text: "Lista",
      map_text: "Karta",
      more_text: "Mer",
      less_text: "Mindre",

      // Operating Hours
      open_text: "Öppet",
      opens_text: "Öppnar",
      open_now_text: "Öppet nu",
      closed_text: "Stängt",
      closes_text: "Stänger",
      closes_soon_text: "Stänger snart",
      hours_might_differ: "Öppettider kan variera",

      // Days
      monday_text: "Måndag",
      tuesday_text: "Tisdag",
      wednesday_text: "Onsdag",
      thursday_text: "Torsdag",
      friday_text: "Fredag",
      saturday_text: "Lördag",
      sunday_text: "Söndag",

      // Units
      miles_text: "mil",
      kilometers_text: "kilometer",
      no_limit_text: "Ingen begränsning",

      // Contact Info
      phone_label_text: "Telefonnummer",
      email_label_text: "E-post"
    },
    'nb-no': {
      // Search Box
      page_title: "Finn forhandlere",
      curr_loc_text: "Nåværende plassering",
      radius_text: "Søkeradius",
      find_loc_btn_text: "Finn min plassering",
      search_btn_text: "Søk",
      enter_a_location_text: "Angi et sted",
      filter_tags_text: "Filtrer tagger",
      location_is_disabled_alert: "Stedstjenester er deaktivert",
      location_is_disabled_text: "Aktiver enhetens plassering for å bruke Finn min plassering",
      msr_text: "Måleenhet for søkeradius",
      meter_unit_text: "Mil",
      kilometer_unit_text: "Kilometer",

      // Results
      no_result_title: "Ingen resultater",
      no_result_tags: "Ingen steder ble funnet med valgte tagger. Endre valgene eller inndataene.",
      add_error_alert: "Kunne ikke finne adressen",
      distance_error_alert: "Dessverre er nærmeste forhandler lenger unna enn",

      // Map & List
      direction_text: "Veibeskrivelse",
      view_map_btn_text: "Vis kart",
      list_text: "Liste",
      map_text: "Kart",
      more_text: "Mer",
      less_text: "Mindre",

      // Operating Hours
      open_text: "Åpent",
      opens_text: "Åpner",
      open_now_text: "Åpent nå",
      closed_text: "Stengt",
      closes_text: "Stenger",
      closes_soon_text: "Stenger snart",
      hours_might_differ: "Åpningstider kan variere",

      // Days
      monday_text: "Mandag",
      tuesday_text: "Tirsdag",
      wednesday_text: "Onsdag",
      thursday_text: "Torsdag",
      friday_text: "Fredag",
      saturday_text: "Lørdag",
      sunday_text: "Søndag",

      // Units
      miles_text: "mil",
      kilometers_text: "kilometer",
      no_limit_text: "Ingen begrensning",

      // Contact Info
      phone_label_text: "Telefonnummer",
      email_label_text: "E-post"
    },
    'de-de': {
      // Search Box
      page_title: "Händler finden",
      curr_loc_text: "Aktueller Standort",
      radius_text: "Suchradius",
      find_loc_btn_text: "Meinen Standort finden",
      search_btn_text: "Suchen",
      enter_a_location_text: "Ort eingeben",
      filter_tags_text: "Tags filtern",
      location_is_disabled_alert: "Standortdienste deaktiviert",
      location_is_disabled_text: "Bitte aktivieren Sie den Standort Ihres Geräts, um Meinen Standort finden zu verwenden",
      msr_text: "Maßeinheit für Suchradius",
      meter_unit_text: "Meilen",
      kilometer_unit_text: "Kilometer",

      // Results
      no_result_title: "Keine Ergebnisse",
      no_result_tags: "Keine Standorte mit den ausgewählten Tags gefunden. Bitte ändern Sie Ihre Auswahl oder Eingabe.",
      add_error_alert: "Adresse konnte nicht gefunden werden",
      distance_error_alert: "Leider ist der nächstgelegene Händler weiter entfernt als",

      // Map & List
      direction_text: "Wegbeschreibung",
      view_map_btn_text: "Karte anzeigen",
      list_text: "Liste",
      map_text: "Karte",
      more_text: "Mehr",
      less_text: "Weniger",

      // Operating Hours
      open_text: "Geöffnet",
      opens_text: "Öffnet",
      open_now_text: "Jetzt geöffnet",
      closed_text: "Geschlossen",
      closes_text: "Schließt",
      closes_soon_text: "Schließt bald",
      hours_might_differ: "Öffnungszeiten können abweichen",

      // Days
      monday_text: "Montag",
      tuesday_text: "Dienstag",
      wednesday_text: "Mittwoch",
      thursday_text: "Donnerstag",
      friday_text: "Freitag",
      saturday_text: "Samstag",
      sunday_text: "Sonntag",

      // Units
      miles_text: "Meilen",
      kilometers_text: "Kilometer",
      no_limit_text: "Keine Begrenzung",

      // Contact Info
      phone_label_text: "Telefonnummer",
      email_label_text: "E-Mail"
    },
    'es-es': {
      // Search Box
      page_title: "Buscar distribuidores",
      curr_loc_text: "Ubicación actual",
      radius_text: "Radio de búsqueda",
      find_loc_btn_text: "Encontrar mi ubicación",
      search_btn_text: "Buscar",
      enter_a_location_text: "Introducir una ubicación",
      filter_tags_text: "Filtrar etiquetas",
      location_is_disabled_alert: "Los servicios de ubicación están desactivados",
      location_is_disabled_text: "Active la ubicación del dispositivo para usar Encontrar mi ubicación",
      msr_text: "Unidad de medida del radio de búsqueda",
      meter_unit_text: "Millas",
      kilometer_unit_text: "Kilómetros",

      // Results
      no_result_title: "Sin resultados",
      no_result_tags: "No se encontraron ubicaciones con las etiquetas seleccionadas. Modifique sus selecciones o entrada.",
      add_error_alert: "No se pudo encontrar la dirección",
      distance_error_alert: "Lamentablemente, el distribuidor más cercano está a más de",

      // Map & List
      direction_text: "Indicaciones",
      view_map_btn_text: "Ver mapa",
      list_text: "Lista",
      map_text: "Mapa",
      more_text: "Más",
      less_text: "Menos",

      // Operating Hours
      open_text: "Abierto",
      opens_text: "Abre",
      open_now_text: "Abierto ahora",
      closed_text: "Cerrado",
      closes_text: "Cierra",
      closes_soon_text: "Cierra pronto",
      hours_might_differ: "Los horarios pueden variar",

      // Days
      monday_text: "Lunes",
      tuesday_text: "Martes",
      wednesday_text: "Miércoles",
      thursday_text: "Jueves",
      friday_text: "Viernes",
      saturday_text: "Sábado",
      sunday_text: "Domingo",

      // Units
      miles_text: "millas",
      kilometers_text: "kilómetros",
      no_limit_text: "Sin límite",

      // Contact Info
      phone_label_text: "Teléfono",
      email_label_text: "Correo Electrónico"
    },
    'pl-pl': {
      // Search Box
      page_title: "Znajdź dystrybutorów",
      curr_loc_text: "Bieżąca lokalizacja",
      radius_text: "Promień wyszukiwania",
      find_loc_btn_text: "Znajdź moją lokalizację",
      search_btn_text: "Szukaj",
      enter_a_location_text: "Wprowadź lokalizację",
      filter_tags_text: "Filtruj tagi",
      location_is_disabled_alert: "Usługi lokalizacji są wyłączone",
      location_is_disabled_text: "Włącz lokalizację urządzenia, aby użyć funkcji Znajdź moją lokalizację",
      msr_text: "Jednostka miary promienia wyszukiwania",
      meter_unit_text: "Mile",
      kilometer_unit_text: "Kilometry",

      // Results
      no_result_title: "Brak wyników",
      no_result_tags: "Nie znaleziono lokalizacji z wybranymi tagami. Zmień wybór lub wprowadzone dane.",
      add_error_alert: "Nie można znaleźć adresu",
      distance_error_alert: "Niestety najbliższy dystrybutor znajduje się dalej niż",

      // Map & List
      direction_text: "Wskazówki dojazdu",
      view_map_btn_text: "Pokaż mapę",
      list_text: "Lista",
      map_text: "Mapa",
      more_text: "Więcej",
      less_text: "Mniej",

      // Operating Hours
      open_text: "Otwarte",
      opens_text: "Otwiera",
      open_now_text: "Otwarte teraz",
      closed_text: "Zamknięte",
      closes_text: "Zamyka",
      closes_soon_text: "Wkrótce zamknięte",
      hours_might_differ: "Godziny otwarcia mogą się różnić",

      // Days
      monday_text: "Poniedziałek",
      tuesday_text: "Wtorek",
      wednesday_text: "Środa",
      thursday_text: "Czwartek",
      friday_text: "Piątek",
      saturday_text: "Sobota",
      sunday_text: "Niedziela",

      // Units
      miles_text: "mile",
      kilometers_text: "kilometry",
      no_limit_text: "Brak limitu",

      // Contact Info
      phone_label_text: "Numer telefonu",
      email_label_text: "Adres e-mail"
    }
  };

  // ============================================
  // LANGUAGE DETECTION
  // ============================================

  function detectLanguage() {
    var lang = DEFAULT_LANG;

    // Priority 0: URL path (Shopify locale path like /sv-se/ or /en-gb/)
    try {
      var pathMatch = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)\//i);
      if (pathMatch) {
        var pathLang = pathMatch[1].toLowerCase();
        if (SUPPORTED_LANGS.indexOf(pathLang) !== -1) return pathLang;

        var langCode = pathLang.split('-')[0];
        var matched = SUPPORTED_LANGS.find(function(supported) {
          return supported.split('-')[0] === langCode;
        });
        if (matched) return matched;
      }
    } catch (e) {}

    // Priority 1: URL hash
    try {
      var hash = window.location.hash.replace('#', '').toLowerCase();
      if (hash && SUPPORTED_LANGS.indexOf(hash) !== -1) return hash;
    } catch (e) {}

    // Priority 2: URL parameter
    try {
      var urlParams = new URLSearchParams(window.location.search);
      var urlLang = urlParams.get('lang');
      if (urlLang) {
        urlLang = urlLang.toLowerCase();
        if (SUPPORTED_LANGS.indexOf(urlLang) !== -1) return urlLang;

        var langCode = urlLang.split('-')[0];
        var matched = SUPPORTED_LANGS.find(function(supported) {
          return supported.split('-')[0] === langCode;
        });
        if (matched) return matched;
      }
    } catch (e) {}

    // Priority 3: Shopify locale
    if (window.Shopify && Shopify.locale) {
      var shopifyLang = Shopify.locale.toLowerCase();
      if (SUPPORTED_LANGS.indexOf(shopifyLang) !== -1) return shopifyLang;

      var langCode = shopifyLang.split('-')[0];
      var matched = SUPPORTED_LANGS.find(function(supported) {
        return supported.split('-')[0] === langCode;
      });
      if (matched) return matched;
    }

    // Priority 4: HTML lang attribute
    var htmlLang = document.documentElement.lang;
    if (htmlLang) {
      htmlLang = htmlLang.toLowerCase();
      if (SUPPORTED_LANGS.indexOf(htmlLang) !== -1) return htmlLang;

      var langCode = htmlLang.split('-')[0];
      var matched = SUPPORTED_LANGS.find(function(supported) {
        return supported.split('-')[0] === langCode;
      });
      if (matched) return matched;
    }

    return lang;
  }

  // ============================================
  // APPLY TRANSLATIONS
  // ============================================

  var retryCount = 0;
  var maxRetries = 80; // 8 seconds max wait

  function applyTranslations() {
    // Check if SCASLSetting exists
    if (typeof window.SCASLSetting === 'undefined') {
      retryCount++;
      if (retryCount < maxRetries) {
        setTimeout(applyTranslations, 100);
        return;
      } else {
        return;
      }
    }

    var lang = detectLanguage();
    var dict = TRANSLATIONS[lang] || TRANSLATIONS[DEFAULT_LANG];

    // Override SCASLSetting values
    for (var key in dict) {
      if (dict.hasOwnProperty(key)) {
        window.SCASLSetting[key] = dict[key];
      }
    }

    // ============================================
    // MUTATION OBSERVER ONLY FOR POPUP WINDOW
    // ============================================

    function updatePopupLabels() {
      var popupContainer =
        document.getElementById('scasl-window-container') ||
        document.getElementById('scasl-window-container');

      if (!popupContainer) return;

      var phoneText = dict.phone_label_text || 'Phone Number';
      var emailText = dict.email_label_text || 'Email';

      var phoneLabel = document.getElementById('scasl-phone-label');
      var emailLabel = document.getElementById('scasl-email-label');

      if (phoneLabel) phoneLabel.innerText = phoneText;
      if (emailLabel) emailLabel.innerText = emailText;

      var html = popupContainer.innerHTML;

      // Replace exact English label
      html = html.replace(/Phone Number/g, phoneText);
      html = html.replace(/Email/g, emailText);

      popupContainer.innerHTML = html;
    }

    var popupObserverAttached = false;
    var attachRetry = 0;
    var attachMaxRetry = 100; // 10 seconds
    var throttleTimer = null;

    function attachPopupObserver() {
      var popupContainer = document.getElementById('scasl-window-container');
      if (!popupContainer) {
        attachRetry++;
        if (attachRetry < attachMaxRetry) {
          setTimeout(attachPopupObserver, 100);
        }
        return;
      }

      if (popupObserverAttached) return;
      popupObserverAttached = true;

      // Update immediately when found container
      updatePopupLabels();
      setTimeout(updatePopupLabels, 50);
      setTimeout(updatePopupLabels, 150);

      if (!window.MutationObserver) return;

      var observer = new MutationObserver(function() {
        if (throttleTimer) return;
        throttleTimer = setTimeout(function() {
          throttleTimer = null;
          updatePopupLabels();
        }, 80);
      });

      observer.observe(popupContainer, {
        childList: true,
        subtree: true
      });
    }

    attachPopupObserver();
  }

  // ============================================
  // INIT
  // ============================================

  applyTranslations();

})();
